import { ActionReducer, ActionReducerMap, INIT, MetaReducer } from '@ngrx/store'
import { environment } from '../../environments/environment'
import { reducer as casesReducer } from './cases/cases.reducer'
import { reducer as caseReducer } from './case/case.reducer'
import { reducer as plotDataReducer } from './plot-data/plot-data.reducer'
import { reducer as selectionReducer } from './selection/selection.reducer'
import { reducer as viewerReducer } from './viewer/viewer.reducer'
import { reducer as userReducer } from './user/user.reducer'
import { reducer as jobReducer } from './job/job.reducer'
import { CasesEffects } from './cases/cases.effects'
import { CaseEffects } from './case/case.effects'
import { CasesState } from './cases/cases.state'
import { CaseState } from './case/case.state'
import { ViewerEffects } from './viewer/viewer.effects'
import { ViewerState } from './viewer/viewer.state'
import { PlotDataState } from './plot-data/plot-data.state'
import { PlotDataEffects } from './plot-data/plot-data.effects'
import { SelectionState } from './selection/selection.state'
import { SelectionEffects } from './selection/selection.effects'
import { UserEffects } from './user/user.effects'
import { userActions } from './user/user.actions'
import { UserState } from './user/user.state'
import { JobEffects } from './job/job.effects'
import { JobState } from './job/job.state'

export const reducers: ActionReducerMap<AppState> = {
    cases: casesReducer,
    case: caseReducer,
    plotData: plotDataReducer,
    selection: selectionReducer,
    viewer: viewerReducer,
    user: userReducer,
    job: jobReducer,
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logout] : [logout]

export const effects = [
    CasesEffects,
    CaseEffects,
    UserEffects,
    ViewerEffects,
    PlotDataEffects,
    SelectionEffects,
    JobEffects,
]

export interface AppState {
    cases: CasesState
    case: CaseState
    plotData: PlotDataState
    selection: SelectionState
    viewer: ViewerState
    user: UserState
    job: JobState
}

export function logout<State>(reducer: ActionReducer<State>): ActionReducer<State> {
    return (state, action) => {
        if (action != null && action.type === userActions.logoutFinished.type) {
            return reducer(undefined, { type: INIT })
        }
        return reducer(state, action)
    }
}
